<!--title -->
<app-modal-title
  [title]="'pages.outboxMessages.advancedSearch.title' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form>
    <!-- help message -->
    <div
      class="flex tw-px-5 tw-my-2 *:tw-text-red-700 *:dark:tw-text-red-200 *:tw-font-medium *:tw-text-[14px]"
    >
      <p [innerHTML]="'messages.outboxAdvancedSearchHelp' | translate"></p>
    </div>

    <div class="row tw-mt-8">
      <!-- phonebooks -->
      <div class="md:tw-w-1/2">
        <h3 class="tw-mr-3 dark:tw-text-gray-200">
          {{ fields + "phonebookIds" | translate }}
        </h3>
        <div class="tw-max-h-[450px] tw-mt-5">
          <phonebook-selection-list
            [showPrivacyDropdown]="false"
            searchLabel="common.search"
            (values)="model.phonebookIds = $event"
            [values]="model.phonebookIds"
            responsiveClass="tw-w-full"
            searchBoxGridclass="tw-w-full"
            [isSmallSize]="true"
          >
          </phonebook-selection-list>
        </div>
      </div>

      <div class="md:tw-w-1/2">
        <!--todo add remove all btn -->
        <!-- <button (click)="removeAll()" class="btn btn-light txt-lg  button-shadow tw-mx-1 btn-hover-rise" type="button"
          mat-ripple [matTooltip]="'common.removeAll'|translate">
          <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0  text-danger "></i>
        </button> -->
        <div class="row tw-mt-8">
          <!-- zipCode -->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              [operator]="
                !model?.zipCode?.operator
                  ? ComparisonOperator.Contains
                  : model.zipCode.operator
              "
              [showModel]="model"
              [fieldName]="'zipCode'"
              [value]="model?.zipCode?.zipCode"
              (value)="setValue($event, 'zipCode', 'zipCode')"
              [type]="'text'"
              [isOnlyNumber]="true"
              [min]="0"
            ></form-field-Advanced-search>
          </div>

          <!--toNumber-->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              [operator]="
                !model?.toNumber?.operator
                  ? ComparisonOperator.EqualTo
                  : model.toNumber.operator
              "
              [showModel]="model"
              [fieldName]="'toNumber'"
              [value]="model?.toNumber?.toNumber"
              (value)="setValue($event, 'toNumber', 'toNumber')"
              [type]="'toNumber'"
              [isOnlyNumber]="true"
            ></form-field-Advanced-search>
          </div>

          <!--guildName-->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              [operator]="
                !model?.guild?.operator
                  ? ComparisonOperator.Contains
                  : model.guild.operator
              "
              [showModel]="model"
              [fieldName]="'guild'"
              [value]="model?.guild?.guildName"
              (value)="setValue($event, 'guild', 'guildName')"
              [type]="'text'"
            ></form-field-Advanced-search>
          </div>

          <!--zoneName-->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              [operator]="
                !model?.zone?.operator
                  ? ComparisonOperator.Contains
                  : model.zone.operator
              "
              [showModel]="model"
              [fieldName]="'zone'"
              [value]="model?.zone?.zoneName"
              (value)="setValue($event, 'zone', 'zoneName')"
              [type]="'text'"
            ></form-field-Advanced-search>
          </div>

          <!--DeliveryStatus -->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              enumName="DeliveryStatus"
              [operator]="
                !model?.deliveryStatus?.operator
                  ? ComparisonOperator.Contains
                  : model.deliveryStatus.operator
              "
              [showModel]="model"
              [fieldName]="'deliveryStatus'"
              [value]="model?.deliveryStatus?.deliveryStatus"
              (value)="setValue($event, 'deliveryStatus', 'deliveryStatus')"
              [type]="'enum'"
            ></form-field-Advanced-search>
          </div>

          <!--SendStatus -->
          <div class="md:tw-w-1/2">
            <form-field-Advanced-search
              enumName="SendStatus"
              [operator]="
                !model?.sendStatus?.operator
                  ? ComparisonOperator.Contains
                  : model.sendStatus.operator
              "
              [showModel]="model"
              [fieldName]="'sendStatus'"
              [value]="model?.sendStatus?.sendStatus"
              (value)="setValue($event, 'sendStatus', 'sendStatus')"
              [type]="'enum'"
            ></form-field-Advanced-search>
          </div>

          <!--startDateTime-->
          <div class="tw-w-full">
            <form-field-Advanced-search
              [showModel]="model"
              [startDateTime]="model?.startDate"
              [endDateTime]="model?.endDate"
              [type]="'dateTime'"
              (startDate)="model.startDate = $event; checkModelValues()"
              (endDate)="model.endDate = $event; checkModelValues()"
            ></form-field-Advanced-search>
          </div>

          <!--smsText-->
          <div class="tw-w-full">
            <form-field-Advanced-search
              [operator]="
                !model?.smsText?.operator
                  ? ComparisonOperator.Contains
                  : model.smsText.operator
              "
              [showModel]="model"
              [fieldName]="'smsText'"
              [value]="model?.smsText?.smsText"
              (value)="setValue($event, 'smsText', 'smsText')"
              [type]="'smsText'"
            ></form-field-Advanced-search>
          </div>

          <!--description-->
          <div class="tw-w-full">
            <form-field-Advanced-search
              [operator]="
                !model?.description?.operator
                  ? ComparisonOperator.Contains
                  : model.description.operator
              "
              [showModel]="model"
              [fieldName]="'description'"
              [value]="model?.description?.description"
              (value)="setValue($event, 'description', 'description')"
              [type]="'textArea'"
            ></form-field-Advanced-search>
          </div>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isDisabled]="isDisabledSubmitBtn"
      [isEdit]="formPageConfig.isEditMode"
      [btnType]="'submit'"
      [customTitle]="'common.search'"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
